import { useEffect, useState } from 'react';
const useCountdown = ({
  targetDate,
  timerCopy = 'Deal expires in'
}) => {
  const [remainingTime, setRemainingTime] = useState('');
  useEffect(() => {
    if (!targetDate) return;
    const calculateTimeLeft = () => {
      const now = new Date();
      const target = new Date(targetDate);
      const difference = target.getTime() - now.getTime();
      if (difference <= 0) {
        setRemainingTime('Deal expired');
        return;
      }
      const timeUnits = [{
        unit: 'd',
        divisor: 86400000
      },
      // 24 * 60 * 60 * 1000
      {
        unit: 'h',
        divisor: 3600000
      },
      // 60 * 60 * 1000
      {
        unit: 'm',
        divisor: 60000
      },
      // 60 * 1000
      {
        unit: 's',
        divisor: 1000
      }];
      let remainingTime = difference;
      const timeString = timeUnits.reduce((acc, {
        unit,
        divisor
      }) => {
        if (remainingTime >= divisor || acc) {
          const value = Math.floor(remainingTime / divisor);
          remainingTime %= divisor;
          return acc + ` ${value}${unit}`;
        }
        return acc;
      }, '');
      setRemainingTime(`${timerCopy}${timeString}`);
    };
    calculateTimeLeft();
    const interval = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(interval);
  }, [targetDate, timerCopy]);
  return remainingTime;
};
export default useCountdown;